import { useToast } from 'primevue/usetoast';
import { useChangePasswordMutation } from '@/types/vue-apollo-helpers';
import type { ChangePasswordInput } from '@/types/composition-functions';

export function useAuthMutations() {
  const toast = useToast();
  const { mutate: changePasswordMutation } = useChangePasswordMutation();

  async function changeUserPassword(input: ChangePasswordInput) {
    try {
      const { data } = (await changePasswordMutation({ input }))!;
      const response = data?.changePassword;

      if (response?.success) {
        toast.add({
          severity: 'success',
          summary: 'Success',
          detail: response.message || 'Password changed successfully!',
          life: 3000,
        });
      } else {
        toast.add({
          severity: 'warn',
          summary: 'Failed',
          detail: response?.message || 'Unable to change password.',
          life: 3000,
        });
      }
      return response;
    } catch (error) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: error instanceof Error ? error.message : 'An error occurred while changing password.',
        life: 3000,
      });
      throw error;
    }
  }

  return {
    changeUserPassword,
  };
}
